
    import { defineComponent, PropType } from "vue";
    import { Item } from "../models"

    export default defineComponent({
        name: "Tile",
        props: {
            item: null as null | PropType<Item>
        }
    });
